import React, { useEffect, useState } from 'react';
import { Button, Result } from 'antd';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";


// 定义错误边界的属性和状态
interface ErrorBoundaryProps {
    children: React.ReactNode;
}

// 类组件：实现错误边界的核心逻辑
const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
    const [hasError, setHasError] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);
    const [errorInfo, setErrorInfo] = useState<any | null>(null);


    useEffect(() => {
        // 捕获全局错误
        const errorHandler = (event: PromiseRejectionEvent | ErrorEvent) => {
            // console.error('Global error:', event);
            setError(event instanceof ErrorEvent ? event.error : event.reason);
            setErrorInfo(event instanceof ErrorEvent ? event.error : event.reason);
            setHasError(true);
        };
        window.addEventListener('error', errorHandler);
        // window.addEventListener('unhandledrejection', errorHandler);

        return () => {
            window.removeEventListener('error', errorHandler);
            window.removeEventListener('unhandledrejection', errorHandler);
        };
    }, []);


    const handleRetry = () => {
        setHasError(false);
        setError(null);
        setErrorInfo(null);
    }


    if (hasError) {
        return <Result status="error" title={t`好像出了点问题...`}
            subTitle={error?.toString()}
            extra={[
                <Button onClick={() => window.location.href = '/'}><Trans>首页</Trans></Button>,
                <Button type="primary" onClick={() => handleRetry()}><Trans>重试</Trans></Button>,
            ]}
        >
            <details style={{ whiteSpace: 'pre-wrap' }}>
                {error?.toString()}
                <br />
                {errorInfo?.componentStack || errorInfo?.stack}
            </details>
        </Result>
    }
    return children;
}

export default ErrorBoundary;